import { BlobProvider } from "@react-pdf/renderer";
import { useState } from "react";
import { AttendanceByDateReport } from "./AttendanceByDateReport";

export default function AttReportByDateBtn({ btnClasses, selectedReport }) {
  /*   All States
   ********************************************* */
  const [showPdf, setShowPdf] = useState(false);

  /*   All Functions
   ********************************************* */

  /*   All UseEffects
   ********************************************* */

  return (
    <>
      {showPdf ? (
        <>
          <BlobProvider
            document={
              <AttendanceByDateReport selectedReport={selectedReport} />
            }
          >
            {({ url, blob }) => {
              const isDisabled = !showPdf || !blob;
              return (
                <span className="d-inline-flex gap-2">
                  <a
                    href={isDisabled ? "#" : url}
                    download={`Attendance-Report-${selectedReport?.date || "download"}.pdf`}
                    className={btnClasses}
                    onClick={(e) => {
                      if (isDisabled) e.preventDefault();
                    }}
                  >
                    <i className="mdi mdi-download"></i>Download Report
                  </a>
                  <a
                    href={isDisabled ? "#" : url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={btnClasses}
                    onClick={(e) => {
                      if (isDisabled) e.preventDefault();
                    }}
                  >
                    <i className="mdi mdi-eye"></i>View Report
                    {!url && (
                      <div
                        className="spinner-border spinner-border-sm text-white ms-2 mb-1"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    )}
                  </a>
                </span>
              );
            }}
          </BlobProvider>
        </>
      ) : (
        <>
          <button
            className={btnClasses}
            onClick={(e) => {
              setShowPdf(true);
            }}
          >
            Generate Report
          </button>
        </>
      )}
    </>
  );
}
